var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBasic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.109 -0.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.232,9.382a.584.584,0,0,0,.583-.586V2.424A1.755,1.755,0,0,0,23.067.667H1.857A1.755,1.755,0,0,0,.109,2.424V28.909a1.755,1.755,0,0,0,1.748,1.758H23.067a1.755,1.755,0,0,0,1.748-1.758V24.592a.583.583,0,1,0-1.165,0v4.317a.585.585,0,0,1-.583.586H1.857a.585.585,0,0,1-.583-.586V2.424a.585.585,0,0,1,.583-.586H23.067a.585.585,0,0,1,.583.586V8.8A.584.584,0,0,0,24.232,9.382Z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.144,8.542a5.532,5.532,0,0,0-3.8,9.558.6.6,0,0,0,.065.06,5.525,5.525,0,0,0,7.465,0,.6.6,0,0,0,.065-.06,5.532,5.532,0,0,0-3.8-9.558Zm0,9.867a4.309,4.309,0,0,1-2.617-.882,3.008,3.008,0,0,1,5.233,0A4.309,4.309,0,0,1,23.144,18.408Zm-.963-4.572v-.391a.963.963,0,0,1,1.925,0v.391a.963.963,0,0,1-1.925,0Zm4.448,2.809a4.174,4.174,0,0,0-1.773-1.486,2.154,2.154,0,0,0,.453-1.323v-.391a2.166,2.166,0,1,0-4.332,0v.391a2.155,2.155,0,0,0,.453,1.323,4.174,4.174,0,0,0-1.773,1.486,4.332,4.332,0,1,1,6.972,0Z",
    transform: "translate(-10.575 -4.626)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.421,64.542H30.172a.6.6,0,0,0,0,1.2h3.249a.6.6,0,1,0,0-1.2Z",
    transform: "translate(-17.678 -38.327)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.879,56.375H17.336a.6.6,0,0,0,0,1.2h8.543a.6.6,0,1,0,0-1.2Z",
    transform: "translate(-10.028 -33.35)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.879,48.208H17.336a.6.6,0,1,0,0,1.2h8.543a.6.6,0,1,0,0-1.2Z",
    transform: "translate(-10.028 -28.461)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.535,40.218a.6.6,0,1,0,.176.425A.606.606,0,0,0,11.535,40.218Z",
    transform: "translate(-6.109 -23.572)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.535,48.385a.6.6,0,1,0,.176.425A.607.607,0,0,0,11.535,48.385Z",
    transform: "translate(-6.109 -28.461)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.535,56.551a.6.6,0,1,0,.176.425A.607.607,0,0,0,11.535,56.551Z",
    transform: "translate(-6.109 -33.35)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.879,40.042H17.336a.6.6,0,0,0,0,1.2h8.543a.6.6,0,1,0,0-1.2Z",
    transform: "translate(-10.028 -23.572)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.146,19.188a2.527,2.527,0,0,0-3.452.925L44.123,33.226a.6.6,0,0,0-.077.234l-.533,4.774a.6.6,0,0,0,.955.551l3.868-2.848a.6.6,0,0,0,.164-.184L56.071,22.64A2.53,2.53,0,0,0,55.146,19.188ZM44.862,37l.278-2.493,1.741,1.005Zm2.9-2.37-2.293-1.324,6.076-10.523,2.293,1.324Zm7.27-12.592-.593,1.027-2.292-1.324.593-1.027a1.324,1.324,0,0,1,2.293,1.324Z",
    transform: "translate(-26.3 -11.485)",
    fill: "#006"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBasic);
export default __webpack_public_path__ + "static/media/icon-basic.6d4e99a69bbb41ce9d2270d6e1051fd7.svg";
export { ForwardRef as ReactComponent };